import { Sizes } from '@sede-x/shell-ds-react-base';

import { SelectSize } from './Select.types';

type SelectConstsType = {
  [size in SelectSize]: {
    icon: {
      right: number;
      top: number;
    };
    tag: {
      paddingTopBottom: number;
      paddingRight: number;
      paddingLeft: number;
    };
    multi: {
      padding: string;
    };
    group: {
      paddingTop: number;
      paddingBottom: number;
      paddingLeft: number;
      paddingRight: number;
    };
    option: {
      paddingTopBottom: number;
      paddingLeft: number;
      paddingRight: number;
    };
    default: {
      paddingTopBottom: number;
      paddingLeft: number;
      paddingRight: number;
      height: number;
    };
  };
};

export const selectConsts: SelectConstsType = {
  [Sizes.Small]: {
    icon: {
      right: 6,
      top: 3,
    },
    tag: {
      paddingTopBottom: 0,
      paddingRight: 5,
      paddingLeft: 2,
    },
    multi: {
      padding: '0 5px',
    },
    group: {
      paddingTop: 6,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    option: {
      paddingTopBottom: 5,
      paddingLeft: 10,
      paddingRight: 30,
    },
    default: {
      paddingTopBottom: 4,
      paddingLeft: 10,
      paddingRight: 30,
      height: 32,
    },
  },
  [Sizes.Medium]: {
    icon: {
      right: 8,
      top: 7,
    },
    tag: {
      paddingTopBottom: 3,
      paddingRight: 5,
      paddingLeft: 6,
    },
    multi: {
      padding: '0 6px',
    },
    group: {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 12,
      paddingRight: 12,
    },
    option: {
      paddingTopBottom: 9,
      paddingLeft: 12,
      paddingRight: 30,
    },
    default: {
      paddingTopBottom: 8,
      paddingLeft: 12,
      paddingRight: 30,
      height: 40,
    },
  },
  [Sizes.Large]: {
    icon: {
      right: 12,
      top: 11,
    },
    tag: {
      paddingTopBottom: 4,
      paddingRight: 6,
      paddingLeft: 8,
    },
    multi: {
      padding: '0 8px',
    },
    group: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 16,
      paddingRight: 16,
    },
    option: {
      paddingTopBottom: 13,
      paddingLeft: 16,
      paddingRight: 30,
    },
    default: {
      paddingTopBottom: 12,
      paddingLeft: 16,
      paddingRight: 30,
      height: 48,
    },
  },
};
